import React, { lazy, Suspense, useContext } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import * as ROUTES from './constants'
import { AuthContext } from '../Auth/Auth'
import { Loading } from '../Loading/Loading'
import { FORM_ROUTES } from '../pages/HealthRecords/Forms'
import 	Registration from '../Registration/Registration'
import 	SubmitVitalSigns from '../Registration/SubmitVitalSigns'
import 	PatientJourney from '../pages/Patients/PatientJourney';
import	GetPatientNumber from '../Registration/GetPatientNumber';
const Home = lazy(() => import('../DashBoards/DashBoardComponents/Home'))
const HomeMap = lazy(() => import('../DashBoards/DashBoardComponents/HomeMap'))
const ChatAI= lazy(() => import('../DashBoards/DashBoardComponents/ChatAI'))
const ToolsDashboard = lazy(() => import('../DashBoards/DashBoardComponents/ToolsDashboard'))

const Connectors = lazy(() => import('../pages/neo/connectors'))
const Services = lazy(() => import('../pages/dynamo/services'))
const Transformers = lazy(() => import('../pages/dynamo/transformers'))
const Jobs = lazy(() => import('../pages/dynamo/jobs'))
const Recipes = lazy(() => import('../pages/dynamo/recipes'))
const RecipeSteps = lazy(() => import('../pages/dynamo/recipe-steps'))
const Triggers = lazy(() => import('../pages/dynamo/triggers'))
const ContentCatalog = lazy(() => import('../pages/breeze/content-catalog'))
const ImageCatalog = lazy(() => import('../pages/breeze/image-catalog'))
const ContentAssociations = lazy(() => import('../pages/breeze/content-associations'))
const ContentCategories = lazy(() => import('../pages/breeze/content-categories'))
const ContentFacades = lazy(() => import('../pages/breeze/content-facades'))
const ContentIndices = lazy(() => import('../pages/breeze/content-indices'))
const ContentTemplates = lazy(() => import('../pages/breeze/content-templates'))
const ContentTypes = lazy(() => import('../pages/breeze/content-types'))
const ContentDescriptors = lazy(() => import('../pages/breeze/content-descriptors'))


const Appointments = lazy(() =>
  import('../pages/Appointments/Appointments')
)
const PrivateRoute = lazy(() => import('./PrivateRoute'))
const AppointmentsCalendar = lazy(() =>
  import('../pages/Appointments/AppointmentsCalendar')
)
const ProviderAppointmentsCalendar = lazy(() =>
  import('../pages/Appointments/ProviderAppointmentsCalendar')
)
const VisitsCalendar = lazy(() =>
  import('../pages/Appointments/VisitsCalendar')
)
const Visits = lazy(() => import('../pages/Appointments/Visits'))

const Labs = lazy(() => import('../pages/HealthRecords/Labs'))
const Patients = lazy(() =>
  import('../pages/Patients/Patients')
)
const Payments = lazy(() =>
  import('../DashBoards/DashBoardComponents/Payments')
)
const Prescriptions = lazy(() =>
  import('../pages/Medications/Prescriptions')
)
const Providers = lazy(() =>
  import('../pages/Providers/Providers')
)
const EhxSsps = lazy(() =>
  import('../pages/Providers/EhxSsps')
)
const Manage_prescriptions = lazy(() =>
  import('../pages/Medications/PrescribePage')
)
const Pharmacists = lazy(() =>
  import('../pages/Pharmacies/Pharmacists')
)
const CareTeams = lazy(() =>
  import('../pages/CareTeams/CareTeam')
)
const ManageCareTeam = lazy(() =>
  import('../pages/CareTeams/ManageCareTeam')
)
const Referrals = lazy(() =>
  import('../DashBoards/DashBoardComponents/Referrals')
)
const HealthCareWorkers = lazy(() =>
  import('../DashBoards/DashBoardComponents/HealthCare')
)

const Documents = lazy(() => import('../pages/UserProfile/Documents'))
const Subscribers = lazy(() =>
  import('../DashBoards/DashBoardComponents/Subscribers')
)

//const CreateEhx = lazy(() => import('../DashBoards/DashBoardForms/CreateEhx'))
const CreateEhxPoc = lazy(() =>
  import('../DashBoards/DashBoardForms/CreateEhxPoc')
)
const ManageLabs = lazy(() => import('../pages/HealthRecords/ManageLabs'))
const ManageDiagnostics = lazy(() => import('../pages/HealthRecords/ManageDiagnostics'))
const EhxPatientForm = lazy(() =>
  import('../pages/Patients/EhxPatientForm')
)
const EhxPaymentForm = lazy(() =>
  import('../DashBoards/DashBoardForms/EhxPaymentForm')
)
const EhxPrescriptionForm = lazy(() =>
  import('../pages/Medications/EhxPrescriptionForm')
)
const EhxProviderForm = lazy(() =>
  import('../pages/Providers/EhxProviderForm')
)
const EhxProviderScheduleForm = lazy(() =>
  import('../pages/Providers/EhxProviderScheduleForm')
)
const EhxUserProfileForm = lazy(() =>
  import('../DashBoards/DashBoardForms/EhxUserProfileForm')
)
const DashboardContent = lazy(() =>
  import('../DashBoards/DashboardContent/DashboardContent')
)
const EhxChatForm = lazy(() =>
  import('../DashBoards/DashBoardForms/EhxChatForm')
)
const ProviderSettings = lazy(() =>
  import('../pages/UserProfile/ProviderSettings')
)
const SubscriberSettings = lazy(() =>
  import('../pages/UserProfile/SubscriberSettings')
)
const Notifications = lazy(() => import('../pages/UserProfile/Notifications'))
const Accounts = lazy(() => import('../pages/UserProfile/Accounts'))
const UserProfile = lazy(() => import('../pages/UserProfile/UserProfile'))
const HealthFacilities = lazy(() =>
  import('../pages/HealthcareFacilities/HealthFacilities')
)
// const EhxHealthCareFacilityForm = lazy(() =>
//   import('../pages/HealthcareFacilities/EhxHealthCareFacilityForm')
// )

const EhxAppointmentFormPatientNew = lazy(() =>
  import('../pages/Appointments/Patient/New')
)
const EhxAppointmentFormPatientEdit = lazy(() =>
  import('../pages/Appointments/Patient/Edit')
)
const EhxAppointmentFormProviderNew = lazy(() =>
  import('../pages/Appointments/Provider/New')
)
const EhxAppointmentFormProviderEdit = lazy(() =>
  import('../pages/Appointments/Provider/Edit')
)
const EhxVisitFormProviderNew = lazy(() =>
  import('../pages/Appointments/NewVisit')
)

const EhxSubscriberForm = lazy(() =>
  import('../DashBoards/DashBoardForms/EhxSubscriberForm')
)
const EhxVisitFormPatient = lazy(() =>
  import('../pages/Appointments/EhxVisitFormPatient')
)
const EhxVisitFormProvider = lazy(() =>
  import('../pages/Appointments/EhxVisitFormProvider')
)
const Subscriptions = lazy(() =>
  import('../DashBoards/DashBoardComponents/Subscriptions')
)

const AdminAllUsers = lazy(() => import('../pages/Admin/Users'))
const AdminPatients = lazy(() => import('../pages/Admin/Patients'))
const AdminSubscriberDetails = lazy(() =>
  import('../pages/Admin/SubscriberDetails')
)

const AdminNewPatient = lazy(() =>
  import('../pages/Admin/adminForms/OnboardPatientForm')
)

const AdminNewProvider = lazy(() =>
  import('../pages/Admin/adminForms/OnboardProviderForm')
)

const AdminNewEhxSsp = lazy(() =>
  import('../pages/Admin/adminForms/OnboardEhxSspForm')
)
const AdminSspDetails = lazy(() => import('../pages/Admin/SspDetails'))

// CLAIMS
const ClaimsDashboard = lazy(() =>
  import('../DashBoards/DashBoardComponents/claims/ClaimsDashboard')
)
const ClinicalReview = lazy(() => import('../DashBoards/DashBoardComponents/claims/ClinicalReview'))

// PRIOR AUTHORIZATIONS
// const PADashboard = lazy(() =>
//   import('../DashBoards/DashBoardComponents/prior-authorizations/PADashboard')
// )

// UTILIZATION MANAGEMENT
const UMDashboard = lazy(() =>
  import('../DashBoards/DashBoardComponents/utilization-management/UMDashboard')
)

// FORMS MANAGEMENT
const FormsDashboard = lazy(() =>
  import('../DashBoards/DashBoardComponents/forms/FormsDashboard')
)
const PdfFormFiller = lazy(() =>
  import('../DashBoards/DashBoardComponents/forms/PdfFormFiller')
)

// TRAINING MANAGEMENT
const TrainingDashboard = lazy(() =>
  import('../pages/Training/TrainingDashboard')
)
const ManagePatientForms = lazy(() =>
  import('../DashBoards/DashBoardComponents/forms/ManagePatientForms')
)

// VIEWERS
const ViewCareTeams = lazy(() => import('../pages/CareTeams/ViewCareTeams'))
const ViewDiagnostics = lazy(() => import('../pages/HealthRecords/ViewDiagnostics'))
const ViewLabs = lazy(() => import('../pages/HealthRecords/ViewLabs'))
const ViewMessages = lazy(() => import('../pages/Communications/ViewMessages'))
const ViewPfhs = lazy(() => import('../pages/HealthRecords/ViewPfhs'))
const ViewPhrs = lazy(() => import('../pages/HealthRecords/ViewPhrs'))
const ViewReferrals = lazy(() => import('../DashBoards/DashboardContent/ViewReferrals'))
const ViewRxs = lazy(() => import('../pages/Medications/ViewRxs'))
const ViewTasks = lazy(() => import('../pages/Workflow/ViewTasks'))
const ViewHealthcareFacility = lazy(() => import('../pages/HealthcareFacilities/ViewHealthcareFacility'))

const CreatePhrs = lazy(() => import('../pages/HealthRecords/CreatePhrs'))
const CreateLabs = lazy(() => import('../pages/HealthRecords/CreateLabs'))
const CreateDiagnostics = lazy(() => import('../pages/HealthRecords/CreateDiagnostics'))
const CreateRxs = lazy(() => import('../pages/Medications/CreateRxs'))
const CreateCareTeams = lazy(() => import('../pages/HealthRecords/CreateCareTeams'))
const CreatePfhs = lazy(() => import('../pages/HealthRecords/CreatePfhs'))
const CreateTasks = lazy(() => import('../pages/Workflow/CreateTasks'))
const CreateMessages = lazy(() => import('../pages/Communications/CreateMessages'))
const CreateAmls = lazy(() => import('../pages/HealthRecords/CreateAmls'))

const ViewVitalSigns = lazy(() => import('../pages/HealthRecords/ViewVitalSigns'))
const ManageVitalSigns = lazy(() => import('../pages/HealthRecords/ManageVitalSigns'))
const ManagePhrs = lazy(() => import('../pages/HealthRecords/ManagePhrs'))
const ManageActiveMedLists = lazy(() => import('../pages/Medications/ManageActiveMedLists'))
const ManageEhxRx = lazy(() => import('../pages/Medications/ManageRx'))
const ManagePfhs = lazy(() => import('../pages/HealthRecords/ManagePfhs'))
const ManageHealthcareFacility = lazy(() => import('../pages/HealthcareFacilities/ManageHealthcareFacility'))


// const CreateCareTeams = lazy(() =>
//   import('../DashBoards/DashBoardForms/CreateCareTeam')
// )

const RouterConfig = ({ sessionObject, membershipType }) => {

//const userMetadata = useContext(AuthContext)

	//console.log('************ BAD CODE IN ROUTER CONFIG WITH HARDCODED USERMETADATA MUST BE REMOVED ************')
	const userMetadata = {"customerId":1,"membershipType":"3002","userId":520,"apiKey":"linkedin|rz1MycKLaZ","stripe":{"id":"cus_MvcUINmEfdcIFK","object":"customer","subscriptions":{"object":"list","data":[],"has_more":false,"total_count":0,"url":"/v1/customers/cus_MvcUINmEfdcIFK/subscriptions"}}}
	
	// if (userMetadata == null || userMetadata.membershipType == null)
// 	{
// 		console.log('fixing up routerconfig.usermeta.membershipType to 3000');
// 		userMetadata.membershipType = "3000";  
//     }
//    console.log('RouterConfig.usermeta - ' + JSON.stringify(userMetadata));

	return (
    	<Suspense fallback={<Loading />}>
      	<Switch>

        <Route path={ROUTES.REGISTER_PATIENT}>
          <Registration />
        </Route>
        <Route path={ROUTES.SUBMIT_VITAL_SIGNS}>
          <SubmitVitalSigns />
        </Route>
        <Route path={ROUTES.GET_PATIENT_NUMBER}>
        	<GetPatientNumber />
        </Route>
        <Route path={ROUTES.SUBSCRIBERS}>
          <Subscribers />
        </Route>
        <Route path={ROUTES.SUBSCRIPTIONS}>
          <Subscriptions />
        </Route>
        <Route path={ROUTES.VISITS_CALENDAR}>
          <VisitsCalendar />
        </Route>
        <Route path={ROUTES.PRESCRIPTIONS}>
          <Prescriptions />
        </Route>

        <Route path={ROUTES.LABS}>
          <Labs />
        </Route>
        <Route path={ROUTES.PAYMENTS}>
          <Payments />
        </Route>
        <Route path={ROUTES.CREATE_PROVIDER}>
          <EhxProviderForm />
        </Route>
        <Route path={ROUTES.CREATE_PATIENT}>
          <EhxPatientForm />
        </Route>

        {/**
         *  APPOINTMENTS RELATED ROUTES
         */}
         
        <Route path={ROUTES.CREATE_APPOINTMENT}>
            <EhxAppointmentFormPatientNew />
        </Route>
        <Route path={ROUTES.CREATE_VISIT}>
            <EhxVisitFormProviderNew />
        </Route>

		{/*
          {parseInt(userMetadata.membershipType) !== 3000 ? (
            <EhxAppointmentFormProviderNew />
          ) : (
          )}

          {parseInt(userMetadata.membershipType) !== 3000 ? (
          ) : (


          */}

        <Route path={ROUTES.UPDATE_APPOINTMENT_PATIENT}>
            <EhxAppointmentFormPatientEdit />
        </Route>
        <Route path={ROUTES.UPDATE_APPOINTMENT_PROVIDER}>
            <EhxAppointmentFormProviderEdit />
        </Route>
        <Route path={ROUTES.APPOINTMENTS_CALENDAR}>
          <AppointmentsCalendar />
        </Route>
        <Route path={ROUTES.PROVIDER_APPOINTMENTS_CALENDAR}>
          <ProviderAppointmentsCalendar />
        </Route>
        <Route path={ROUTES.APPOINTMENTS}>
          <Appointments />
        </Route>

        <Route path={ROUTES.CREATE_PRESCRIPTION}>
          <EhxPrescriptionForm />
        </Route>
        <Route path={ROUTES.CREATE_PAYMENT}>
          <EhxPaymentForm />
        </Route>
        <Route path={ROUTES.UPDATE_PATIENT}>
          <EhxPatientForm />
        </Route>
        <PrivateRoute path={ROUTES.PATIENTS}>
          <Patients />
        </PrivateRoute>
        <Route path={ROUTES.UPDATE_VISIT}>
          {parseInt(userMetadata.membershipType) !== 3000 ? (
            <EhxVisitFormProvider />
          ) : (
            <EhxVisitFormPatient />
          )}
        </Route>
        <Route path={ROUTES.PHARMACISTS}>
          <Pharmacists />
        </Route>
        <Route path={ROUTES.CARE_TEAMS}>
          <CareTeams />
        </Route>
        <Route path={ROUTES.CREATE_CARE_TEAMS}>
          <CreateCareTeams />
        </Route>
        <Route path={ROUTES.MANAGE_CARE_TEAMS}>
          <ManageCareTeam />
        </Route>
        <Route path={ROUTES.REFERRAL}>
          <Referrals />
        </Route>
        <Route path={ROUTES.MANAGE_PRESCRIPTIONS}>
          <Manage_prescriptions />
        </Route>
        <Route path={ROUTES.MANAGE_ACTIVE_MED_LISTS}>
        	<ManageActiveMedLists />
        </Route>
        <Route path={ROUTES.MANAGE_RX}>
        	<ManageEhxRx />
        </Route>
        <Route path={ROUTES.MANAGE_PFHS}>
        	<ManagePfhs />
        </Route>
        <Route path={ROUTES.HEALTHCARE_WORKERS}>
          <HealthCareWorkers />
        </Route>
        <Route path={ROUTES.VISITS}>
          <Visits />
        </Route>
        <Route path={ROUTES.MANAGE_SUBSCRIBER}>
          <EhxSubscriberForm />
        </Route>

        <Route path={ROUTES.MANAGE_LABS}>
          <ManageLabs />
        </Route>
        <Route path={ROUTES.MANAGE_DIAGNOSTICS}>
          <ManageDiagnostics />
        </Route>
        <Route path={ROUTES.MANAGE_PAYMENT}>
          <EhxPaymentForm />
        </Route>

        {/* Healthcare facilites */}
        <Route path={ROUTES.VIEW_HEALTHCARE_FACILITY}>
          <ViewHealthcareFacility />
        </Route>
        <Route path={ROUTES.MANAGE_HEALTHCARE_FACILITY}>
          <ManageHealthcareFacility />
        </Route>
        <Route path={ROUTES.HEALTHCARE_FACILITY}>
          <HealthFacilities />
        </Route>

        <Route path={ROUTES.CHAT}>
          <EhxChatForm />
        </Route>

        {/* User Profile */}
        <Route
          path={ROUTES.USER_PROFILE}
          render={props => (
            <UserProfile {...props} sessionObject={sessionObject} />
          )}
        />

        {/* Providers */}
        <Route path={ROUTES.UPDATE_PROVIDER}>
          <EhxProviderForm />
        </Route>
        <Route path={ROUTES.PROVIDERS}>
          <Providers />
        </Route>

        <Route path={ROUTES.DOCUMENTS_FILL_FORM}>
          <PdfFormFiller backTo={ROUTES.DOCUMENTS} />
        </Route>
        {FORM_ROUTES.map(({ path, component: FormComponent }) => (
          <Route key={path} exact path={path}>
            <FormComponent />
          </Route>
        ))}
        <Route exact path={ROUTES.DOCUMENTS}>
          <Documents sessionObject={sessionObject} />
        </Route>

        <Route path={ROUTES.PROVIDER_SETTINGS}>
          <ProviderSettings />
        </Route>

        {/* SSPs */}
        <Route path={ROUTES.ADMIN_SSP_DETAILS}>
          <AdminSspDetails />
        </Route>
        <Route path={ROUTES.ADMIN_LIST_SSPS}>
          <EhxSsps />
        </Route>

        {/*  Admin Routes  */}
        <Route exact path={ROUTES.ADMIN_NEW_PATIENT}>
          <AdminNewPatient />
        </Route>
        <Route exact path={ROUTES.ADMIN_NEW_PROVIDER}>
          <AdminNewProvider />
        </Route>
        <Route exact path={ROUTES.ADMIN_NEW_SSP}>
          <AdminNewEhxSsp />
        </Route>
        <Route path={ROUTES.ADMIN_SUBSCRIBER_DETAILS}>
          <AdminSubscriberDetails />
        </Route>
        <Route exact path={ROUTES.ADMIN_ALL_SUBSCRIBERS}>
          <AdminAllUsers />
        </Route>
        <Route exact path={ROUTES.ADMIN_PATIENTS}><AdminPatients /></Route>
        <Route path={ROUTES.NOTIFICATIONS}>
          <Notifications />
        </Route>
        <Route path={ROUTES.ACCOUNTS}>
          <Accounts />
        </Route>

        <Route path={ROUTES.CHAT_AI}>
          <ChatAI />
        </Route>

        <Route path={ROUTES.TOOLS_DASHBOARD}>
          <ToolsDashboard />
        </Route>

        {/* 
        	EHX TOOLS DASHBOARD ROUTES
         */}
        <Route path={ROUTES.CONNECTORS}><Connectors /></Route>
		<Route path={ROUTES.SERVICES}><Services /></Route>
		<Route path={ROUTES.TRANSFORMERS}><Transformers /></Route>
		<Route path={ROUTES.JOBS}><Jobs /></Route>
		<Route path={ROUTES.RECIPES}><Recipes /></Route>
		<Route path={ROUTES.RECIPE_STEPS}><RecipeSteps /></Route>
		<Route path={ROUTES.TRIGGERS}><Triggers /></Route>
		<Route path={ROUTES.CONTENT_CATALOG}><ContentCatalog /></Route>
		<Route path={ROUTES.IMAGE_CATALOG}><ImageCatalog /></Route>
		<Route path={ROUTES.CONTENT_ASSOCIATIONS}><ContentAssociations /></Route>	
		<Route path={ROUTES.CONTENT_CATEGORIES}><ContentCategories /></Route>
		<Route path={ROUTES.CONTENT_DESCRIPTORS}><ContentDescriptors /></Route>
		<Route path={ROUTES.CONTENT_FACADES}><ContentFacades /></Route>
		<Route path={ROUTES.CONTENT_INDICES}><ContentIndices /></Route>
		<Route path={ROUTES.CONTENT_TEMPLATES}><ContentTemplates /></Route>
		<Route path={ROUTES.CONTENT_TYPES}><ContentTypes /></Route>


        <Route path={ROUTES.MAP}>
          <HomeMap />
        </Route>

		{/* CLAIMS */}
        <Route path={ROUTES.CLAIMS}><ClaimsDashboard /></Route>

		{/* UTILIZATION MANAGEMENT */}
        <Route path={ROUTES.UTILIZATION_MANAGEMENT}><UMDashboard /></Route>

		{/* FORMS MANAGEMENT */}
        <Route path={ROUTES.ADMIN_FILL_FORM}>
          <PdfFormFiller />
        </Route>
        <Route exact path={ROUTES.ADMIN_FORMS_DASHBOARD}><FormsDashboard /></Route>
        <Route path={ROUTES.ADMIN_MANAGE_PATIENT_FORMS}><ManagePatientForms /></Route>

		{/* TRAINING MANAGEMENT */}
        <Route path={ROUTES.TRAINING_DASHBOARD}><TrainingDashboard /></Route>

        <Route
          path={ROUTES.HOME}
          render={props => <Home {...props} membershipType={membershipType} />}
        />

        {/* 
        		Create EHX Entities 
		*/}

		<Route path={ROUTES.CREATE_SUBSCRIBERS}><FormsDashboard /></Route>
		<Route 
			path={ROUTES.CREATE_PHRS}
			render={props => <CreatePhrs {...props} sessionObject={sessionObject} />}
		/>
		<Route path={ROUTES.CREATE_LABS}><CreateLabs /></Route>
		<Route path={ROUTES.CREATE_DIAGNOSTICS}><CreateDiagnostics /></Route>
		<Route path={ROUTES.CREATE_RXS}><CreateRxs /></Route>
		<Route path={ROUTES.CREATE_TASKS}><CreateTasks /></Route>
		<Route path={ROUTES.CREATE_MESSAGES}><CreateMessages /></Route>
		<Route path={ROUTES.CREATE_PFHS}><CreatePfhs /></Route>
		<Route path={ROUTES.MANAGE_VITAL_SIGNS}><ManageVitalSigns /></Route>
		<Route path={ROUTES.MANAGE_PHRS}><ManagePhrs /></Route>
        
        
        {/* 
        		Viewers 

		<Route path={ROUTES.VIEW_PROVIDERS}><FormsDashboard /></Route>
		<Route path={ROUTES.VIEW_APPOINTMENTS}><FormsDashboard /></Route>
		<Route path={ROUTES.VIEW_VISITS}><FormsDashboard /></Route>
		<Route path={ROUTES.VIEW_PATIENTS}><FormsDashboard /></Route>
		<Route path={ROUTES.VIEW_SUBSCRIBERS}><FormsDashboard /></Route>
		<Route path={ROUTES.VIEW_LAB_FACILITIES}><FormsDashboard /></Route>
		<Route path={ROUTES.VIEW_HEATHCARE_FACILITIES}><FormsDashboard /></Route>
		<Route path={ROUTES.VIEW_PAYMENTS}><FormsDashboard /></Route>
        
        */}


		<Route path={ROUTES.VIEW_CARE_TEAMS}><ViewCareTeams /></Route>
		<Route path={ROUTES.VIEW_PRESCRIPTIONS}><ViewRxs /></Route>
		<Route path={ROUTES.VIEW_PHRS}><ViewPhrs /></Route>
		<Route path={ROUTES.VIEW_LABS}><ViewLabs /></Route>
		<Route path={ROUTES.VIEW_DIAGNOSTICS}><ViewDiagnostics /></Route>
		<Route path={ROUTES.VIEW_RXS}><ViewRxs /></Route>
		<Route path={ROUTES.VIEW_TASKS}><ViewTasks /></Route>
		<Route path={ROUTES.VIEW_MESSAGES}><ViewMessages /></Route>
		<Route path={ROUTES.VIEW_PFHS}><ViewPfhs /></Route>
		<Route path={ROUTES.VIEW_VITAL_SIGNS}><ViewVitalSigns /></Route>

        <Route path={ROUTES.PATIENT_JOURNEY}><PatientJourney /></Route>

        

        <Route path="/" exact>
          <Redirect to={ROUTES.HOME} />
        </Route>
      </Switch>
    </Suspense>
  )
}

export default RouterConfig
